
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
// import { AppConstant } from './../../shared/constant/app.constant';
import { Injectable } from '@angular/core';


import { AuthHttp } from './token.service';
import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class StaffService {
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    getAllStaff() {
        return this.http.get(`setup/staff`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getAllSensitivityLevel() {
        return this.http.get(`setup/sensitivitylevel`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getStaffInfoById(staffId) {
        return this.http.get(`setup/${staffId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getApprovalStatus() {
        return this.http.get(`setup/approval-status`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getStaffAwaitingApprovals() {
        return this.http.get(`setup/staff/approvals/temp`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getStaffDeleteRequestAwaitingApprovals() {
        return this.http.get(`setup/staff-delete/approvals/temp`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getStaffAwaitingApprovalsById(staffId) {
        return this.http.get(`setup/staff/approvals/temp/${staffId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getStaffActualDetailsByCode(staffCode) {
        return this.http.get(`setup/staff/approvals/${staffCode}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getStaffActualDetails() {

        return this.http.get(`setup/staff/approvals`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addStaff(body) {

        let bodyObj = JSON.stringify(body);
        return this.http.post(`setup/staff`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }

    updateStaff(id, staff) {
        let bodyObj = JSON.stringify(staff);
        return this.http.put(`setup/staff/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateSupervisor(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setup/staff/update-supervisor`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    approveStaff(formObj) {
        let body = JSON.stringify(formObj);
        
        return this.http.post(`setup/staff/approval`, formObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    approveStaffDelete(formObj) {
        let body = JSON.stringify(formObj);
        
        return this.http.post(`setup/staff-delete/approval`, formObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    } 

    approveBulkStaff(formObj) {
        let body = JSON.stringify(formObj);
        return this.http.post(`setup/staff/bulk-approval`, formObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    uploadFile(file: File, body: any) {
        // let bodyObj = JSON.stringify(body);
        return new Promise((resolve, reject) => {

            let url = `setup/staff/upload-signature`;
            // let url = `media/upload-file`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();
            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            xhr.send(formData);
        });
    }

    uploadStaffRecordFile(file: File, body: any) {
        // let bodyObj = JSON.stringify(body);
        return new Promise((resolve, reject) => {

            let url = `setup/staff/multiple-staff-data`;
            // let url = `media/upload-file`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();
            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            xhr.send(formData);
        });
    }

    removeStaff(staffId) {
        return this.http.delete(`setup/staff/${staffId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllStaffSignatures() {
        return this.http.get(`setup/staff/signature/all`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getSupportingDocumentByStaffCode(staffCode) {
        return this.http.get(`setup/staff/signature/?staffCode=${staffCode}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getSampleStaffBulkUploadDocument() {
        return this.http.get(`setup/staff/sample-document`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}